import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-update-property-status-dialog',
  templateUrl: './update-property-status-dialog.component.html',
  styleUrls: ['./update-property-status-dialog.component.scss']
})
export class UpdatePropertyStatusDialogComponent implements OnInit {

  properties = [];
  targetStatus: number;
  projectId: number;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log(this.data)
    this.properties = this.data.properties
    this.targetStatus = this.data.targetStatus
    this.projectId = this.data.projectId
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {

    const ids = this.properties.map(p => p.id).toString();

    const fd = new FormData();
    fd.append('ids', ids);
    fd.append('status', this.targetStatus.toString());
    this.httpService.updatePropertyBatch(fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {

        this.toastrService.success('Properties has been updated.');
        this.dialogRef.close({properties: res.data, projectId: this.projectId});
      } else if (res.code === 0) {
        this.toastrService.error('Failed to update property');
      }
    });
  }
}
